import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { CompareArrowsRounded } from '@mui/icons-material';

type ActionResponse = { netProfileId: string }[];
type ActionArgs = { privateProfileId?: string; competitorNetProfileIds?: string[] };

export type AndieUpdateProfileCompetitorsProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieUpdateProfileCompetitors = (props: AndieUpdateProfileCompetitorsProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.update-profile-competitors.title')}
            icon={<CompareArrowsRounded fontSize="small" />}
            privateProfileId={props.args?.privateProfileId}
            loadingMessages={() => [t('andie.tool.update-profile-competitors.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.update-profile-competitors.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieUpdateProfileCompetitors;
